
import axios from "../services/axios-config";



export const getCompanyData = async (id) => {
    return new Promise(async (resolve, reject) => {
        try {
    
            const res = await axios.get(`/admin/companies/data`, {
                params: {
                    id: id,
                }
            })
    
            if (res.status == 200) {
    
                return resolve({data: res.data});
            }
    
        } catch (error) {
            console.error('ERROR - GET COMPANY DATA FUNCTION:', error);
            reject(error);
    
        }

    })
}